
import cookies from "vue-cookies";
import GLOBAL from '../public/lib/config.js';
import store from './store'
export default {

  isHasLogin:function(){
    let usr_id = store.getters.getUsrId();
    let yun_usrId = store.getters.getYunUsrId();
    let yun_token = store.getters.getYunToken();
    let token = store.getters.getToken();
    if(usr_id  && yun_usrId && yun_token && token){
      return true
    }else{
      return false
    }
  },

  yunLoginVerify:function(){
     
    /*测试用代码，后期需删除 */
    // cookies.set('map_access_token_web','eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJpc3N1c2VyIiwiYXVkIjoiYXVkaWVuY2UiLCJ1c2VyX25hbWUiOiIxODIxMDI1MTc3OCIsInBpZCI6IjE0ODE0NDIyMzc4MjI2MTU1NTMiLCJ0b2tlbl90eXBlIjoiYWNjZXNzX3Rva2VuIiwicm9sZV9uYW1lIjoiIiwibWFpbl9hY2NvdW50Ijp0cnVlLCJ1c2VyX2lkIjoiMTQ4MTQ0MjIzNzgyMjYxNTU1MyIsInJvbGVfaWQiOiItMiIsImRldGFpbCI6eyJ0eXBlIjoid2ViIn0sImFjY291bnQiOiIxODIxMDI1MTc3OCIsImNsaWVudF9pZCI6ImZyb250IiwiZXhwIjoxNzAwMDEwMDUxLCJuYmYiOjE2OTc0MTgwNTF9.bB_MKX8ugxl-37kWt61txL4NWW84kaKfr7WOEk-mi_Q')
    /*测试用代码，结束 */

    //首先判断是否是已登录状态
    var isLogin = false
    // var isLogin = this.isHasLogin();
    // if(isLogin == true) return {'isLogin':true};


    //未登录，根据yunToken获取信息
    var user_id = null;
    var nick_name = null;
    // var is1stOpenPage = false;
    var yun_userId = null;
    var token = null;

    var yun_token= cookies.get('map_access_token_web')
 
    if(yun_token){
      yun_token = yun_token.replace('bearer ','');
    
      $.ajax({
        url: GLOBAL.ServerIP +"/webMap/getUserInfoByToken",
        type:'post',
        data:{"token":yun_token},
        async:false,
        success:function(msg){
           //验证成功，存储用户信息
           if(msg.code == "1"){
            //没有过期
              if(msg.data.isExpire == 0){
                isLogin = true;
                user_id = msg.data.userId; //在线制图用户id
                yun_userId = msg.data.cloudUserId; //云平台用户id
                nick_name = msg.data.userName;
                token = msg.data.token; //在线制图后台token，用于后台接口验证
                // let flag = cookies.get('is1stOpenPage')
                // if(!flag){ //如果没有值，说明是第一次登陆
                //   is1stOpenPage = true;
              }
           }
        }
      })
    }

    // if(is1stOpenPage){
    //   $.ajax({
    //     url: GLOBAL.ServerIP +"/webMap/userIdentify",
    //     type:'post',
    //     data:{"userID":user_id,'expTime':exp_time},
    //     async:false,
    //     success:function(data){
    //        if(data.code == "1"){
    //           user_id = data.userId;
    //           store.commit('setToken',data.token)
    //           cookies.set('is1stOpenPage','false')
    //        }
    //     }
    //   })
    // }

    /*测试用代码，后期需删除 */
      //  user_id = '1481442237822615553'
      //  nick_name = '18210251778'
      //  isLogin = true
    /*测试用代码，结束 */
   
      store.commit('setYunUsrId',yun_userId)
      store.commit('setUsrId',user_id) 
      store.commit('setUsrName',nick_name)
      store.commit('setToken',token)
      store.commit('setYunToken',yun_token)
    
    return {'isLogin':isLogin}
  }
}

